// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { productGridContainerStyle } from "@synd/App/Components/ProductGridCard/ProductGridContainer";
import { xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

productGridContainerStyle.container = {
    css: css`
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        border-radius: 0;
        background-color: transparent;
        box-shadow: none;
        box-sizing: border-box;
        ${xScreen("lte", "sm")} {
            margin: 0 auto;
        }
        ${xScreen("lte", "xs")} {
            max-width: 100%;
        }

        & > .top-section {
            margin-bottom: 8px;
            &:empty {
                display: none;
            }
        }
        & > .middle-section {
            margin-bottom: 8px;
            &:empty {
                display: none;
            }
        }
        & > .bottom-section {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 8px;
            justify-content: flex-end;
            & > .product-grid-container-availability {
                min-height: 43px;
                > div:empty {
                    display: none;
                }
            }
            &:empty {
                display: none;
            }
        }
    `,
};

productGridContainerStyle.image = {
    css: css`
        position: relative;
        height: 100%;
        margin: 0 auto;
        ${StyledButton} {
            min-width: 317px;
            max-width: 317px;
            min-height: 317px;
            max-height: 317px;
            img {
                max-width: 100%;
                max-height: 100%;
                height: auto;
            }
        }
    `,
};

productGridContainerStyle.info = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 4px;
        &:empty {
            display: none;
        }
    `,
};

productGridContainerStyle.price = {
    css: css`
        &:empty {
            display: none;
        }
    `,
};

productGridContainerStyle.availability = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        &:empty {
            display: none;
        }
    `,
};

productGridContainerStyle.addToCartActions = {
    css: css`
        display: flex;
        &:empty {
            display: none;
        }
    `,
};

productGridContainerStyle.addToList = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 12px;
        align-self: flex-end;
        &:empty {
            display: none;
        }
    `,
};

productGridContainerStyle.extraContent = {
    css: css`
        &:empty {
            display: none;
        }
    `,
};
